import { useState } from 'react'
import { useImmer } from 'use-immer'
import { Button, FormControl, FormErrorMessage, FormLabel, Input, VStack } from '@chakra-ui/react'
import { changePassword } from 'api'
import { useAppContext } from 'hooks/useAppContext'

export const PasswordForm = () => {
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [form, setForm] = useImmer({
    currentPassword: '',
    password: '',
    passwordConfirmation: ''
  })
  const [formError, setFormError] = useImmer({
    currentPassword: '',
    password: ''
  })

  const handleChange = (e) => {
    setForm(draft => {
      draft[e.target.name] = e.target.value
    })

    if (formError[e.target.name]) {
      setFormError(draft => { draft[e.target.name] = '' })
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    setIsSubmitting(true)
    try {
      await changePassword(form.currentPassword, form.password)
      setForm(draft => {
        draft.currentPassword = ''
        draft.password = ''
        draft.passwordConfirmation = ''
      })
      createToast('success', 'Password updated.')
      setIsSubmitting(false)
    } catch (err) {
      if (err.response.status === 400) {
        setFormError(err.response.data)
      } else {
        createToast('error', 'Error', err.response.data)
      }
      setIsSubmitting(false)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <VStack gap={2} maxW="500px" mb={8}>
        <FormControl isInvalid={formError.currentPassword} isRequired>
          <FormLabel>Current Password</FormLabel>
          <Input type="password" name="currentPassword" value={form.currentPassword} onChange={handleChange} />
          {formError.currentPassword && <FormErrorMessage>{formError.currentPassword}</FormErrorMessage>}
        </FormControl>
        <FormControl isInvalid={formError.password} isRequired>
          <FormLabel>Password</FormLabel>
          <Input type="password" name="password" value={form.password} onChange={handleChange} />
          {formError.password && <FormErrorMessage>{formError.password}</FormErrorMessage>}
        </FormControl>
        <FormControl isRequired>
          <FormLabel>Confirm Password</FormLabel>
          <Input type="password" name="passwordConfirmation" value={form.passwordConfirmation} onChange={handleChange} />
        </FormControl>
      </VStack>
      <Button type="submit" colorScheme="blue" isLoading={isSubmitting}>Change Password</Button>
    </form>
  )
}
